import config from '../../config';
import type { AprimoAsset } from '../components/studio/ImageModal/AprimoImageModal/types';
import type { BynderAsset } from '../components/studio/ImageModal/BynderImageModal/types';
import type { CloudinaryAsset } from '../components/studio/ImageModal/CloudinaryImageModal/types';
import type { StudioAsset } from '../reducers/studio/assets';
import type { AssetSource } from '../types/AssetSource';
import { APRIMO_SOURCE, BYNDER_SOURCE, CLOUDINARY_SOURCE, INTERNAL_SOURCE } from '../types/AssetSource';
import type { RemoteAsset } from '../types/FieldModel';
import { SUPPORTED_IMAGE_EXTENSIONS } from './project-consts';

export const getAssetUrl = (asset: StudioAsset | RemoteAsset, assetSource: AssetSource, containerUrl?: string): string | undefined => {
    if (assetSource.type === CLOUDINARY_SOURCE.type && 'asset' in asset) {
        const cloudinaryAsset = asset.asset as CloudinaryAsset;
        return cloudinaryAsset.derived?.[0]?.secure_url ?? asset.asset.secure_url;
    } else if (assetSource.type === BYNDER_SOURCE.type && 'asset' in asset) {
        const bynderAsset = asset.asset as BynderAsset;
        if (bynderAsset.type === 'IMAGE' && SUPPORTED_IMAGE_EXTENSIONS.includes(bynderAsset.extensions[0] ?? '')) {
            return bynderAsset.selectedFile?.url ?? bynderAsset.files.webImage.url;
        }
        return bynderAsset.files.webImage.url;
    } else if (assetSource.type === APRIMO_SOURCE.type && 'asset' in asset) {
        const aprimoAsset = asset.asset as AprimoAsset;
        return aprimoAsset.rendition?.publicuri;
    } else if (assetSource.type === INTERNAL_SOURCE.type) {
        const builtInAsset = asset as unknown as StudioAsset;
        return builtInAsset.url;
    } else if (assetSource.type === 'iframe' && containerUrl) {
        return undefined;
        // todo enable when the route is enabled

        // try {
        //     const { url } = await getAssetUrlFromSource(containerUrl, asset);
        //     return url;
        // } catch (error) {
        //     logger.error('Cant get asset url from source', { error, assetSourceName: assetSource.name, assetSourceType: assetSource.type });
        //     return undefined;
        // }
    }
    return undefined;
};

export const getCoreAppUrl = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const coreAppDeployPreviewNumber = queryParams.get('core-deploy-preview-number');

    if (coreAppDeployPreviewNumber) {
        return `https://deploy-preview-${coreAppDeployPreviewNumber}--${config.core_app.deploy_preview_domain}`;
    }
    return config.core_app.base_url;
};
